import React from 'react'
import { LegalFormStepsContextProvider } from '../../context/LegalFormContext'
import { LegalFormStepRoutes } from '../../routes/LegalFormRoutes/LegalForm'

export default function LegalFormWithStepsContext() {
  return (
    <LegalFormStepsContextProvider>
      <LegalFormStepRoutes />
    </LegalFormStepsContextProvider>
  )
}
